
import Dashboard from "views/Dashboard.js";
import Notifications from "views/Notifications.js";
import Icons from "views/Icons.js";
import Typography from "views/Typography.js";
import TableList from "views/Table1.js";
import TableList2 from "views/Table2";
import TableList3 from "views/Table3";
import TableList4 from 'views/Table4';
import Maps from "views/Map.js";
import UserPage from "views/User.js";
import UpgradeToPro from "views/Upgrade.js";

// var routes = [
//   {
//     path: "/dashboard",
//     name: "Dashboard",
//     icon: "nc-icon nc-bank",
//     component: Dashboard,
//     layout: "/admin",
//   },
//   {
//     path: "/icons",
//     name: "Icons",
//     icon: "nc-icon nc-diamond",
//     component: Icons,
//     layout: "/admin",
//   },
//   {
//     path: "/maps",
//     name: "Maps",
//     icon: "nc-icon nc-pin-3",
//     component: Maps,
//     layout: "/admin",
//   },
//   {
//     path: "/notifications",
//     name: "Notifications",
//     icon: "nc-icon nc-bell-55",
//     component: Notifications,
//     layout: "/admin",
//   },
//   {
//     path: "/user-page",
//     name: "User Profile",
//     icon: "nc-icon nc-single-02",
//     component: UserPage,
//     layout: "/admin",
//   },
//   {
//     path: "/tables",
//     name: "Table List",
//     icon: "nc-icon nc-tile-56",
//     component: TableList,
//     layout: "/admin",
//   },
//   {
//     path: "/typography",
//     name: "Typography",
//     icon: "nc-icon nc-caps-small",
//     component: Typography,
//     layout: "/admin",
//   }
// ];

var routes = [
  {
    path: "/table1",
    name: "MEN HELLOFRESH TEAM COMPETITION",
    icon: "nc-icon nc-tile-56",
    component: TableList,
    layout: "/admin",
    type: 'men',
  },
  {
    path: "/table2",
    name: "MEN COLAVITA INDIVIDUAL LEADER",
    icon: "nc-icon nc-tile-56",
    component: TableList2,
    layout: "/admin",
    type: 'men',
  },
  {
    path: "/table3",
    name: "MEN PRIMAL BEST YOUNG RIDER",
    icon: "nc-icon nc-tile-56",
    component: TableList3,
    layout: "/admin",
    type: 'men',
  },
  {
    path: "/table4",
    name: "MEN BIKEREG LAP LEADER",
    icon: "nc-icon nc-tile-56",
    component: TableList4,
    layout: "/admin",
    type: 'men',
  },



  {
    path: "/table5",
    name: "WOMEN HELLOFRESH TEAM COMPETITION",
    icon: "nc-icon nc-tile-56",
    component: TableList,
    layout: "/admin",
    type: 'women',
  },
  {
    path: "/table6",
    name: "WOMEN COLAVITA INDIVIDUAL LEADER",
    icon: "nc-icon nc-tile-56",
    component: TableList2,
    layout: "/admin",
    type: 'women',
  },
  {
    path: "/table7",
    name: "WOMEN PRIMAL BEST YOUNG RIDER",
    icon: "nc-icon nc-tile-56",
    component: TableList3,
    layout: "/admin",
    type: 'women',
  },
  {
    path: "/table8",
    name: "WOMEN BIKEREG LAP LEADER",
    icon: "nc-icon nc-tile-56",
    component: TableList4,
    layout: "/admin",
    type: 'women',
  },





  {
    path: "/",
    pathTo: "/results",
    name: "HELLO FRESH TEAM COMPETITION",
    redirect: true
  }
];
export default routes;
